import { useState } from "react";
import { useLocation } from "react-router-dom";
import emailjs from "emailjs-com";
import { FormStep } from "../components/FormStep";

export const Question = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initialAskTo = searchParams.get("askTo") || "Klajdi";

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    age: "",
    country: "",
    email: "",
    gender: "",
    question: "",
    askTo: initialAskTo,
  });
  const [error, setError] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAskToChange = (askTo) => {
    setFormData((prevData) => ({ ...prevData, askTo }));
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (!formData.email) {
      setError("Email is required");
      return;
    }
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      setError("Please enter a valid email address.");
      return;
    }
    setError("");
    setStep(2);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.question) {
      setError("Please enter your question");
      return;
    }
    setError("");

    // Send email to Admin (You)
    const adminTemplateParams = {
      user_name: formData.name,
      user_age: formData.age,
      user_country: formData.country,
      user_email: formData.email,
      user_gender: formData.gender,
      question: formData.question,
      ask_to: formData.askTo,
      sent_at: new Date().toLocaleString(),
    };

    emailjs
      .send(
        "your_service_id",
        "your_admin_template_id",
        adminTemplateParams,
        "your_user_id"
      )
      .then(
        (response) => {
          console.log("Admin email sent successfully:", response);
        },
        (error) => {
          console.log("Error sending admin email:", error);
        }
      );

    // Send auto-reply to User
    const userTemplateParams = {
      user_name: formData.name,
      user_email: formData.email,
      question: formData.question,
    };

    emailjs
      .send(
        "your_service_id",
        "your_user_template_id",
        userTemplateParams,
        "your_user_id"
      )
      .then(
        (response) => {
          console.log("Auto-reply sent to user:", response);
        },
        (error) => {
          console.log("Error sending auto-reply:", error);
        }
      );

    setIsSubmitted(true);
  };

  const renderStep1 = () => (
    <FormStep title="Tell me about yourself">
      <div className="flex justify-center space-x-4 w-full mb-4">
        <button
          type="button"
          className={`px-4 py-2 rounded-lg w-full ${
            formData.askTo === "Klajdi"
              ? "bg-white text-black"
              : "bg-white/20 text-white"
          }`}
          onClick={() => handleAskToChange("Klajdi")}
        >
          Ask Klajdi
        </button>
        <button
          type="button"
          className={`px-4 py-2 rounded-lg w-full  ${
            formData.askTo === "Ida"
              ? "bg-white text-black"
              : "bg-white/20 text-white"
          }`}
          onClick={() => handleAskToChange("Ida")}
        >
          Ask Ida
        </button>
      </div>
      <form onSubmit={handleNext} className="space-y-4">
        <input
          type="text"
          name="name"
          className="w-full p-3 bg-white/10 border border-white/30 rounded-lg text-white placeholder-white/50 focus:ring-0 focus:border focus:border-white"
          placeholder="Your name (optional)"
          value={formData.name}
          onChange={handleChange}
        />
        <select
          name="gender"
          className="w-full p-3 bg-white/10 border border-white/30 rounded-lg text-white placeholder-white/50 focus:ring-0 focus:border focus:border-white"
          value={formData.gender}
          onChange={handleChange}
        >
          <option value="">Select Gender (optional)</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Prefer not to say">Prefer not to say</option>
          <option value="Other">Other</option>
        </select>
        <input
          type="number"
          name="age"
          className="w-full p-3 bg-white/10 border border-white/30 rounded-lg text-white placeholder-white/50"
          placeholder="Your age (required)"
          value={formData.age}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="country"
          className="w-full p-3 bg-white/10 border border-white/30 rounded-lg text-white placeholder-white/50"
          placeholder="Your country (required)"
          value={formData.country}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          className="w-full p-3 bg-white/10 border border-white/30 rounded-lg text-white placeholder-white/50"
          placeholder="Your email address (required)"
          value={formData.email}
          onChange={handleChange}
          required
        />
        {error && <p className="text-red-500 text-sm">{error}</p>}
        <button
          type="submit"
          className="w-full bg-white text-black font-medium py-3 px-6 rounded-lg transition-all duration-300 hover:bg-white/90"
        >
          Next
        </button>
      </form>
    </FormStep>
  );

  const renderStep2 = () => (
    <FormStep title={`Your question for ${formData.askTo}`}>
      <form
        onSubmit={handleSubmit}
        className="flex flex-col justify-between space-y-4 h-full"
      >
        <textarea
          name="question"
          className="w-full p-3 bg-white/10 border border-white/30 rounded-lg text-white placeholder-white/50 resize-none h-60 flex-grow"
          placeholder="Type your question here..."
          value={formData.question}
          onChange={handleChange}
          required
        />
        {error && <p className="text-red-500 text-sm">{error}</p>}
        <div className="flex space-x-4">
          <button
            type="button"
            onClick={() => setStep(1)}
            className="w-1/2 bg-white/20 text-white font-medium py-3 px-6 rounded-lg transition-all duration-300 hover:bg-white/30"
          >
            Back
          </button>
          <button
            type="submit"
            className="w-1/2 bg-white text-black font-medium py-3 px-6 rounded-lg transition-all duration-300 hover:bg-white/90"
          >
            Submit
          </button>
        </div>
      </form>
    </FormStep>
  );

  const renderThankYou = () => (
    <div className="text-center flex flex-col justify-center items-center h-full ">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        className="w-16 h-16 text-green-500 mx-auto mb-4"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
      <h2 className="text-2xl font-bold text-white mb-4">Thank You!</h2>
      <p className="text-white text-lg">
        Your question has been submitted successfully to {formData.askTo}
      </p>
    </div>
  );

  return (
    <div className="h-screen  flex flex-col items-center justify-center p-4 bg-gradient-to-br from-black/90 to-black">
      <h1 className="absolute top-10 left-1/2 transform -translate-x-1/2 text-white  text-3xl">
        KIQ.WORLD
      </h1>
      <div className="w-full h-auto max-w-md bg-white/10 backdrop-blur-xl rounded-xl p-8 shadow-2xl">
        {isSubmitted
          ? renderThankYou()
          : step === 1
          ? renderStep1()
          : renderStep2()}
      </div>
    </div>
  );
};
